import fp from 'lodash/fp';
export {useFormController, usePageController} from './hooks';
import {Field} from './fields';

export const TOOLS = fp.pick(
    ['SIGNATURE', 'DATE', 'TEXTBOX', 'ORDERSBOX', 'CHECKBOX'],
    Field.TOOLS,
);
